const form = {
  formId: "new-user-form",
  formField: {
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "[01] Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    bank: {
      name: "bank",
      label: "[02] Ngân hàng thương mại, tổ chức trung gian thanh toán:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên ngân hàng thương mại, tổ chức trung gian thanh toán",
    },
    taxId: {
      name: "taxId",
      label: "[05] Mã số thuế nộp thay:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế nộp thay",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    totalTax: {
      name: "totalTax",
      label: "Tổng số thuế GTGT và thuế TNDN phải nộp kỳ này (Viết bằng chữ):",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế nộp thay",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    //
    signer: {
      name: "signer",
      label: "Người ký:",
      type: "text",
      errorMsg: "Vui lòng nhập tên người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký:",
      type: "number",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
